module.exports = __webpack_public_path__ + "static/media/piatto_4.93b1f2cd.png";